import { render } from "./ProfileDatatable.vue?vue&type=template&id=4cf5dff3"
import script from "./ProfileDatatable.vue?vue&type=script&lang=js"
export * from "./ProfileDatatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__